// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderSummaryCardStyles } from "@guestsupply/Overrides/Components/OrderSummaryCard";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

orderSummaryCardStyles.orderSummaryCardGridItem = { width: 12 };

orderSummaryCardStyles.dataCell = {
    css: css`
        a > span {
            font-size: 13px;
        }
        max-width: unset;
        ${TypographyStyle} {
            white-space: nowrap;
        }
    `,
};

orderSummaryCardStyles.shipToCell = {
    css: css`
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: unset;
        ${TypographyStyle} {
            white-space: nowrap;
        }
    `,
};

orderSummaryCardStyles.customerPOCell = {
    css: css`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
};
